import React from "react";
import { useTranslation } from "react-i18next";
import BreadCrumb from "components/breadcrumb";
import MainHeader from "components/header";
import Payout from "components/main/payout";

const Payouts = () => {
  const {t, i18n} = useTranslation('common');
  const nav = [
    {
      url: "/affiliate/overview",
      label: t("general.dashboard"),
    },
    {
      url: "/affiliate/payouts",
      label: t("payout.title"),
      main: true,
    },
  ];
  return (
    <>
      <MainHeader title={t("payout.title")} />
      <BreadCrumb links={nav} />
      <Payout />
    </>
  );
};

export default Payouts;
